var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZones(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "35 36 36 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6_copy",
    transform: "translate(-236.554 -298.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70158",
    "data-name": "Group 70158",
    transform: "translate(277.143 338.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63397",
    "data-name": "Path 63397",
    d: "M305.634,387.282l-12.341-5.871-.15-.087a3.833,3.833,0,0,0-.854-.358,2.967,2.967,0,0,0-1.842-.008,1.281,1.281,0,0,0-.158.076l-.059.034-12.845,6.069c-.387.321-.275,2.138.1,2.312l1.592,1.081,2.284,1.318,8.607,4.97a3.222,3.222,0,0,0,2.854.291l9.941-5.74,2.5-1.446.21-.121C306.134,389.42,306.068,387.492,305.634,387.282Z",
    transform: "translate(-277.143 -367.778)",
    fill: "#6d861d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_70156",
    "data-name": "Group 70156",
    transform: "translate(0.112 11.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63398",
    "data-name": "Path 63398",
    d: "M292.208,379.089l-12.045,6.955c-.3.173-.166.635.5,1.022l.767.443,10.66-.239Z",
    transform: "translate(-279.242 -378.206)",
    fill: "#b3e40c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63399",
    "data-name": "Path 63399",
    d: "M302.368,415.753a2.2,2.2,0,0,0,1.77.291l9.355-5.4-19.23.431Z",
    transform: "translate(-289.115 -400.065)",
    fill: "#b3e40c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63400",
    "data-name": "Path 63400",
    d: "M340.98,387.692l.105-.061c.3-.172.166-.634-.5-1.021l-11.144-6.434-.108,7.777Z",
    transform: "translate(-313.407 -378.959)",
    fill: "#b3e40c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63401",
    "data-name": "Path 63401",
    d: "M296.027,377.745l-.61.352-.113,8.18-10.66.239,2.955,1.707,19.23-.431,3.195-1.844-11.651.261.108-7.777-.684-.395A2.2,2.2,0,0,0,296.027,377.745Z",
    transform: "translate(-282.451 -377.215)",
    fill: "#ebf0a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63402",
    "data-name": "Path 63402",
    d: "M292.54,376.365a2.966,2.966,0,0,0-1.842-.008,1.234,1.234,0,0,0-.158.076l-.059.034-12.6,7.273c-.659.38-.438,1.1.5,1.648l.937.541,2.284,1.318,8.607,4.97a3.22,3.22,0,0,0,2.854.291l9.942-5.74,2.5-1.446.21-.121c.659-.38.438-1.1-.5-1.648l-11.678-6.742-.15-.087A3.838,3.838,0,0,0,292.54,376.365Zm1,1.066,11.144,6.434c.67.387.8.849.5,1.021l-.105.061-3.195,1.844-9.355,5.4a2.2,2.2,0,0,1-1.77-.291l-8.1-4.68-2.955-1.707-.767-.443c-.67-.387-.8-.849-.5-1.022l12.045-6.955.61-.352a2.2,2.2,0,0,1,1.77.291Z",
    transform: "translate(-277.506 -376.215)",
    fill: "#ebf0a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_70157",
    "data-name": "Group 70157",
    transform: "translate(6.609 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63403",
    "data-name": "Path 63403",
    d: "M314.62,405.373c-.68,0-1.231.318-1.231.711s.551.711,1.231.711,1.23-.318,1.23-.711S315.3,405.373,314.62,405.373Z",
    transform: "translate(-308.862 -384.79)",
    fill: "#de7d01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63404",
    "data-name": "Path 63404",
    d: "M329.763,341.109l-.049-.025c.031.016.061.033.091.05C329.79,341.126,329.778,341.117,329.763,341.109Z",
    transform: "translate(-320.171 -340.253)",
    fill: "#c60d05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63405",
    "data-name": "Path 63405",
    d: "M299.787,347.386c-.574-4.994,3.338-7.678,6.1-8.38a3.246,3.246,0,0,1,2.264.179,6.265,6.265,0,0,0-3.192-.763c-2.76.7-6.821,3.586-6.248,8.58.413,3.617,3.636,8.807,4.538,9.188.085.036.965.469,1.078.384C303.759,356.68,300.2,351,299.787,347.386Z",
    transform: "translate(-298.654 -338.379)",
    fill: "#de7d01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63406",
    "data-name": "Path 63406",
    d: "M315.858,347.539a3.37,3.37,0,0,1,.979,3.158c-.279,2.374-1.967,4.668-3.772,5.129a2.466,2.466,0,0,1-.662.079,1.923,1.923,0,0,0,1.74.3c1.806-.461,3.494-2.754,3.773-5.129C318.152,349.036,317.265,347.6,315.858,347.539Z",
    transform: "translate(-308.179 -344.725)",
    fill: "#de7d01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63407",
    "data-name": "Path 63407",
    d: "M310.928,340.534l-.057-.037c-.052-.033-.1-.065-.158-.095-.03-.018-.059-.034-.091-.05l-.049-.025a3.246,3.246,0,0,0-2.264-.179c-2.76.7-6.671,3.385-6.1,8.38.413,3.618,3.972,9.294,4.537,9.189,1.36-.249,5.366-8.653,5.786-12.277C312.8,343.151,312.145,341.364,310.928,340.534Zm-.111,5.342c-.279,2.375-1.967,4.668-3.773,5.129a1.923,1.923,0,0,1-1.74-.3,3.8,3.8,0,0,1-1.032-3.162,5.257,5.257,0,0,1,3.772-5.129,2.434,2.434,0,0,1,.716-.074C310.166,342.4,311.053,343.832,310.817,345.877Z",
    transform: "translate(-301.08 -339.521)",
    fill: "#fcaf48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZones);
export default __webpack_public_path__ + "static/media/Zones.8eb8e98dd8cbfd7c4bf02baa4446cd20.svg";
export { ForwardRef as ReactComponent };